import { memo, splitProps } from '../helpers.js';
import { createRecipe, mergeRecipes } from './create-recipe.js';

const focusRingFn = /* @__PURE__ */ createRecipe('focus-ring', {
  "kind": "bordered"
}, [])

const focusRingVariantMap = {
  "kind": [
    "bordered",
    "filled"
  ]
}

const focusRingVariantKeys = Object.keys(focusRingVariantMap)

export const focusRing = /* @__PURE__ */ Object.assign(memo(focusRingFn.recipeFn), {
  __recipe__: true,
  __name__: 'focusRing',
  __getCompoundVariantCss__: focusRingFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: focusRingVariantKeys,
  variantMap: focusRingVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, focusRingVariantKeys)
  },
  getVariantProps: focusRingFn.getVariantProps,
})